import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { AccountTypeEnum } from "../../data/enums";

export namespace FinanceAccountValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                accountType: v.optional(v.picklist(AccountTypeEnum.values)),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            initialBalance: v.pipe(v.number(), v.integer(), v.minValue(0)),
            accountType: v.picklist(AccountTypeEnum.valuesCreate),
            bankName: v.optional(baseVals.string()),
            accountNumber: v.optional(baseVals.string()),
            accountHolder: v.optional(baseVals.string()),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            bankName: v.exactOptional(baseVals.string()),
            accountNumber: v.exactOptional(baseVals.string()),
            accountHolder: v.exactOptional(baseVals.string()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );
}
